/** Betrouwbaarheidsniveaus (FR-06): laag/middel/hoog. */
export const CONFIDENCE_LEVELS = ['low', 'medium', 'high'];
export const CONFIDENCE_LABELS = {
    low: 'Lage zekerheid',
    medium: 'Gemiddelde zekerheid',
    high: 'Hoge zekerheid',
};
/** Tekstvelden van het bedrijfsprofiel, met NL-label. */
export const PROFILE_TEXT_FIELDS = [
    { key: 'name', label: 'Bedrijfsnaam' },
    { key: 'industry', label: 'Branche' },
    { key: 'geographicFocus', label: 'Geografische focus' },
    { key: 'targetAudience', label: 'Doelgroep' },
];
/** Lijstvelden (meerdere waarden), met NL-label. */
export const PROFILE_LIST_FIELDS = [
    { key: 'services', label: 'Diensten' },
    { key: 'propositions', label: 'Proposities' },
    { key: 'keywords', label: 'Belangrijke zoekwoorden' },
];
export const PROFILE_FIELD_LABELS = {
    name: 'Bedrijfsnaam',
    industry: 'Branche',
    geographicFocus: 'Geografische focus',
    targetAudience: 'Doelgroep',
    services: 'Diensten',
    propositions: 'Proposities',
    keywords: 'Belangrijke zoekwoorden',
};
//# sourceMappingURL=profile.js.map